const NETWORK_STATUS = {
  ONLINE: 'online',
  OFFLINE: 'offline'
}

const NETWORK_DOMAIN = 'appNetwork'
const NETWORK_STATE = {
  status: NETWORK_STATUS.ONLINE
}

const NETWORK_PATH = {
  STATUS: `${NETWORK_DOMAIN}.status`
}

export {
  NETWORK_STATUS,
  NETWORK_DOMAIN,
  NETWORK_PATH,
  NETWORK_STATE
}
